const tableWrapper = () => {
  const tables = document.querySelectorAll('.rtf table');

  tables.forEach(table => {
    
    if(!table.closest('.rtf__table-wrapper')) {
      const container = document.createElement('div');
      const newTable = table.cloneNode(true);
      container.classList.add('rtf__table-wrapper');
      container.appendChild(newTable);
  
      table.parentNode.replaceChild(container, table);
    }
  });
};

export default tableWrapper;
